/** Etiquetas de presentación para tipos de evento de historial de catálogo. */

export const getProductCatalogEventTypeLabel = (eventType: string) => {
  switch (eventType) {
    case 'create':
      return 'Nuevo';
    case 'update':
      return 'Editado';
    case 'deactivate':
      return 'Desactivado';
    case 'reactivate':
      return 'Activado';
    case 'bulk_price':
      return 'Cambio de precios';
    default:
      return eventType || '—';
  }
};
